import { inject, Injectable } from "@angular/core"
import { Actions, createEffect, ofType } from "@ngrx/effects"
import { catchError, exhaustMap, map, throwError } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { userActions } from "./user.actions";
import { User } from "../../models/user.model";
import { Store } from "@ngrx/store";
@Injectable()
export class UsersEffects {

    private httpClient = inject(HttpClient);
    private actions$ = inject(Actions);
    private store = inject(Store)

    load$ = createEffect(() => 
        this.actions$.pipe(
            ofType(userActions.loadUsers),
            exhaustMap(() => {
                const req = this.httpClient.get<User[]>(`${environment.api}/user/all`);

                return req.pipe(
                    map((payload) => userActions.loadUsersSuccess({payload})),
                    catchError((error) => {
                        this.store.dispatch(userActions.loadUsersFail());
                        return throwError(() => new Error(error));
                    })
                )
            })
        )
    )

    get$ = createEffect(() =>
        this.actions$.pipe(
            ofType(userActions.getUserInfo),
            exhaustMap(({data}) => {
                const req = this.httpClient.get<User>(`${environment.api}/user/editInfo/${data}`);

                return req.pipe(
                    map((payload) => userActions.getUserInfoSuccess({payload})),
                    catchError((error) => {
                        this.store.dispatch(userActions.getUserInfoFail());
                        return throwError(() => new Error(error));
                    })
                )
            })
        )
    )

    add$ = createEffect(() =>
        this.actions$.pipe(
            ofType(userActions.addUser),
            exhaustMap(({data}) => {
                const req = this.httpClient.post(`${environment.api}/user`, data);

                return req.pipe(
                    map((_) => userActions.loadUsers())
                )
            })
        )
    )

    edit$ = createEffect(() =>
        this.actions$.pipe(
            ofType(userActions.editUser),
            exhaustMap(({data}) => {
                const req = this.httpClient.put(`${environment.api}/user/${data.user_id}`, data);

                return req.pipe(
                    map((_) => userActions.loadUsers())
                )
            })
        )
    )

    delete$ = createEffect(() =>
        this.actions$.pipe(
            ofType(userActions.deleteUser),
            exhaustMap(({data}) => {
                const req = this.httpClient.delete(`${environment.api}/user/${data}`);

                return req.pipe(
                    map((_) => userActions.loadUsers())
                )
            })
        )
    )
}